export const PEOPLE = {
  DEFAULT: 1,
  MIN: 1,
  MAX: 10
};

export const MULTI_ADD = {
  DEFAULT_ROW: 2,
  DEFAULT_COLUMN: 2,
  DEFAULT_HORIZONTAL_SPACING: 1,
  DEFAULT_VERTICAL_SPACING: 1
};

export const GRID = {
  SIZE: 20,
  ITEM_WIDTH: 2,
  ITEM_HEIGHT: 2
};

export const GRID_ITEM = {
  MARGIN_LEFT: 1,
  MARGIN_TOP: 101
};

export const TEXT_LABEL = {
  INITIAL_WIDTH: 6,
  INITIAL_HEIGHT: 2
};

export const MESSAGE_TIMEOUT = 3000;

export const DOMAIN = 'https://jotform-widget.netlify.app';

export const ACTION_STATUS_MAP = {
  approve: 'approved',
  deny: 'denied'
};
